/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * waterTemperature
 */

import $ from 'jquery';

const waterTemperature = {
    cfg: {
        wrapper: document.querySelectorAll('.js-waterTemperature'),
        language: 'de',
    },

    init() {
        if (this.cfg.wrapper.length > 0) {
            /* eslint-disable */
            $.getJSON('/weather/latest_temperature.json')
                .done((data) => {
                    this.cfg.wrapper.forEach((wrapper) => {
                        wrapper.querySelector('.js-currentWaterTemp').innerHTML = `${Math.round(data.water*10)/10}&deg;C`.replace('.', ',');
                    });
                })
                .fail(() => {});
            /* eslint-enable */
        }
    }
};

export default waterTemperature;



// WEBPACK FOOTER //
// ./___src/templates/_molecules/waterTemperature/_script.js